import React from 'react';

export interface EquipoIconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

const EquipoIcon: React.FC<EquipoIconProps> = ({ 
  size = 24, 
  color = 'currentColor',
  className = '' 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <g stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" clip-path="url(#a)"><path d="M14.577 15.41a3.35 3.35 0 0 0-2.37-.98h-6.7a3.35 3.35 0 0 0-3.351 3.35v1.676M12.208 7.728a3.35 3.35 0 1 1-6.702 0 3.35 3.35 0 0 1 6.701 0m12.569 13.196v-1.68a3.36 3.36 0 0 0-3.36-3.359h-6.718a3.36 3.36 0 0 0-3.359 3.36v1.679M21.417 9.167a3.36 3.36 0 1 1-6.718 0 3.36 3.36 0 0 1 6.718 0"/></g><defs><clipPath id="a"><path fill="currentColor" d="M.985.866h25v25h-25z"/></clipPath></defs>
    </svg>
  );
};

export default EquipoIcon;
